export const adverseMediaRiskLevels = [
  { label: 'Unknown', value: 'unknown' },
  { label: 'Acknowledged High', value: 'acknowledged_high' },
  { label: 'Acknowledged Medium', value: 'acknowledged_medium' },
  { label: 'High', value: 'high' },
  { label: 'Medium', value: 'medium' },
  { label: 'Low', value: 'low' }
]
